import React from "react";
import { BrowserRouter, Routes, Route, } from 'react-router-dom'
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './views/ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import Dashboard from './views/Dashboard';
import CarTypes from './views/CarTypes';
import AddBookings from './views/AddBookings';
import Promos from './views/Promos';
import Banners from './views/Banners';
import DynamicHours from './views/DynamicHours';
import Zones from './views/Zones';
import Users from './views/Users';
import CustomerDetails from "views/CustomerDetails.js";
import Notifications from './views/Notifications';
import Settings from './views/Settings.js';
import Complain from "views/Complain.js";
import AddMoney from "./views/AddMoney";
import Withdraws from './views/Withdraws';
import AllReports from "./views/AllReports";
import { FirebaseProvider, store } from "common";
import { FirebaseConfig } from './config/FirebaseConfig';
import { GoogleMapApiConfig } from './config/GoogleMapApiConfig';
import { GoogleMapApiOptions } from './mapConfig';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ContactUs from "./views/ContactUs";
import UserWallet from "./views/UserWallet";
import CarsList from "./views/CarsList";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { useJsApiLoader } from '@react-google-maps/api';
import TermCondition from "views/TermCondition.js";
import DriverAgreement from "views/DriverAgreement.js";
import { HelmetProvider } from "react-helmet-async";
import Sos from './views/Sos';
import DriverDetails from "views/DriverDetails.js";
import Error from "views/Error.js";
import BookingDetails from "views/BookingDetails.js";
import UserDocuments from "views/UserDocuments.js";
import AddNotifications from "views/AddNotifications.js";
import EditPromo from "views/EditPromo.js";
import EditDynamicHour from "views/EditDynamicHour.js";
import EditCar from "views/EditCar.js";
import EditCarType from "views/EditCarType.js";
import EditUser from "views/EditUser.js";
import PaymentSettings from "views/PaymentSettings.js";
import Taxes from './views/Taxes';
import Partners from './views/Partners';
import EditPartner from './views/EditPartner';
import BrowsePartners from './views/BrowsePartners';
import PartnerDetail from './views/PartnerDetail';
import PartnerCheckout from './views/PartnerCheckout';
import MyPartnerOrders from './views/MyPartnerOrders';
import PartnerOrderDetail from './views/PartnerOrderDetail';
import PartnerDashboard from './views/PartnerDashboard';
import MyPartner from './views/MyPartner';
import PartnerInventory from './views/PartnerInventory';
import PartnerOrdersInbox from './views/PartnerOrdersInbox';
import AdminPartnerOrders from './views/AdminPartnerOrders';
import AdminPartnerPOS from './views/AdminPartnerPOS';
const libraries = GoogleMapApiOptions.libraries;

i18n
.use(initReactI18next) 
.init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
        escapeValue: false
    }
});

function App() {

  useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: GoogleMapApiConfig,
    version: GoogleMapApiOptions.v,
    libraries
  })

  const theme = createTheme({
    palette: {
      primary: {
        main: '#F97316',
        light: '#FDBA74',
        dark: '#EA580C',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#1F2937',
        light: '#374151',
        dark: '#111827',
        contrastText: '#FFFFFF',
      },
    },
  })

  return (
    <HelmetProvider>
    <Provider store={store}>
      <FirebaseProvider config={FirebaseConfig}>
        <ThemeProvider theme={theme}>
          <AuthLoading>
          <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
              <Routes>
                <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"}><Dashboard /></ProtectedRoute>}/>
                <Route path="/bookings" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><BookingHistory /></ProtectedRoute>}/>
                <Route path="/errands" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><BookingHistory serviceTypeFilter="ERRAND" /></ProtectedRoute>}/>
                <Route path="/bookings/bookingdetails/:id" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><BookingDetails /></ProtectedRoute>}/>
                <Route path="/profile" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"}><MyProfile /></ProtectedRoute>}/>
                <Route path="/cartypes" element={<ProtectedRoute permit={"admin"}><CarTypes /></ProtectedRoute>}/>
                <Route path="/zones" element={<ProtectedRoute permit={"admin"}><Zones /></ProtectedRoute>}/>
                <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><CarsList /></ProtectedRoute>}/>
                <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin,customer"}><AddBookings /></ProtectedRoute>}/>
                <Route path="/promos" element={<ProtectedRoute permit={"admin"}><Promos /></ProtectedRoute>}/>
                <Route path="/banners" element={<ProtectedRoute permit={"admin"}><Banners /></ProtectedRoute>}/>
                <Route path="/taxes" element={<ProtectedRoute permit={"admin"}><Taxes /></ProtectedRoute>}/>
                <Route path="/dynamic-hours" element={<ProtectedRoute permit={"admin"}><DynamicHours /></ProtectedRoute>}/>
                <Route path="/users/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><Users /></ProtectedRoute>}/>
                <Route path="/users/customerdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><CustomerDetails/></ProtectedRoute>}/>
                <Route path="/users/driverdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><DriverDetails/></ProtectedRoute>}/>
                <Route path="/users/userdocuments/:rId/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><UserDocuments/></ProtectedRoute>} />  
                <Route path="/notifications" element={<ProtectedRoute permit={"admin"}><Notifications /></ProtectedRoute>}/>
                <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"}><AddMoney /></ProtectedRoute>}/>
                <Route path="/userwallet" element={<ProtectedRoute permit={"customer,driver,fleetadmin"}><UserWallet /></ProtectedRoute>}/>
                <Route path="/withdraws" element={<ProtectedRoute permit={"admin"}><Withdraws /></ProtectedRoute>}/>
                <Route path="/sos" element={<ProtectedRoute permit={"admin"}><Sos /></ProtectedRoute>}/>
                <Route path="/complain" element={<ProtectedRoute permit={"admin"}><Complain /></ProtectedRoute>}/>
                <Route path="/allreports" element={<ProtectedRoute permit={"admin,fleetadmin"}><AllReports /></ProtectedRoute>}/>
                <Route path="/settings" element={<ProtectedRoute permit={"admin"}><Settings /></ProtectedRoute>}/>
                <Route path="/paymentsettings" element={<ProtectedRoute permit={"admin"}><PaymentSettings /></ProtectedRoute>}/>
                <Route path="/partners" element={<ProtectedRoute permit={"customer,admin,fleetadmin"}><BrowsePartners/></ProtectedRoute>}/>
                <Route path="/partners/:partnerId" element={<ProtectedRoute permit={"customer,admin,fleetadmin"}><PartnerDetail/></ProtectedRoute>}/>
                <Route path="/partners/:partnerId/checkout" element={<ProtectedRoute permit={"customer"}><PartnerCheckout/></ProtectedRoute>}/>
                <Route path="/myorders" element={<ProtectedRoute permit={"customer"}><MyPartnerOrders/></ProtectedRoute>}/>
                <Route path="/myorders/:orderId" element={<ProtectedRoute permit={"customer,admin,partner"}><PartnerOrderDetail/></ProtectedRoute>}/>
                <Route path="/partner/dashboard" element={<ProtectedRoute permit={"partner"}><PartnerDashboard/></ProtectedRoute>}/>
                <Route path="/partner/business" element={<ProtectedRoute permit={"partner"}><MyPartner/></ProtectedRoute>}/>
                <Route path="/partner/inventory" element={<ProtectedRoute permit={"partner"}><PartnerInventory/></ProtectedRoute>}/>
                <Route path="/partner/orders" element={<ProtectedRoute permit={"partner"}><PartnerOrdersInbox/></ProtectedRoute>}/>
                <Route path="/admin/partners" element={<ProtectedRoute permit={"admin"}><Partners/></ProtectedRoute>}/>
                <Route path="/admin/partners/edit/:id" element={<ProtectedRoute permit={"admin"}><EditPartner/></ProtectedRoute>}/>
                <Route path="/admin/partners/orders" element={<ProtectedRoute permit={"admin"}><AdminPartnerOrders/></ProtectedRoute>}/>
                <Route path="/admin/partners/:partnerId/orders" element={<ProtectedRoute permit={"admin"}><AdminPartnerOrders/></ProtectedRoute>}/>
                <Route path="/admin/partners/:partnerId/inventory" element={<ProtectedRoute permit={"admin"}><PartnerInventory/></ProtectedRoute>}/>
                <Route path="/admin/partners/:partnerId/pos" element={<ProtectedRoute permit={"admin"}><AdminPartnerPOS/></ProtectedRoute>}/>
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/term-condition" element={<TermCondition />} />
                <Route path="/driver-agreement" element={<DriverAgreement />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/users/edituser/:usertype" element={<ProtectedRoute permit={"admin,fleetadmin"}><EditUser/></ProtectedRoute>}/>
                <Route path="/users/edituser/:usertype/:id" element={<ProtectedRoute permit={"admin,fleetadmin"}><EditUser/></ProtectedRoute>}/>
                <Route path="/notifications/addnotifications" element={<ProtectedRoute permit={"admin"}><AddNotifications/></ProtectedRoute>}/>
                <Route path="/cars/editcar" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><EditCar/></ProtectedRoute>}/>
                <Route path="/cars/editcar/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><EditCar/></ProtectedRoute>}/>
                <Route path="/promos/editpromo" element={<ProtectedRoute permit={"admin"}><EditPromo/></ProtectedRoute>}/>
                <Route path="/promos/editpromo/:id" element={<ProtectedRoute permit={"admin"}><EditPromo/></ProtectedRoute>}/>
                <Route path="/dynamic-hours/edit" element={<ProtectedRoute permit={"admin"}><EditDynamicHour/></ProtectedRoute>}/>
                <Route path="/dynamic-hours/edit/:id" element={<ProtectedRoute permit={"admin"}><EditDynamicHour/></ProtectedRoute>}/>
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/cartypes/editcartype" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} ><EditCarType/></ProtectedRoute>} />
                <Route path="/cartypes/editcartype/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"}><EditCarType/></ProtectedRoute>}/>
                <Route path="/*" element={<Error/>} />
                <Route path="/" element={<LandingPage />} />
              </Routes>
            </BrowserRouter>
          </AuthLoading>
        </ThemeProvider>
      </FirebaseProvider>
    </Provider>
    </HelmetProvider>
  );
}

export default App;
